export const NS = 'map';
export const SET_MAP_BOUNDS = `${NS}/SET_MAP_BOUNDS`;
